<template>
<ValidationObserver ref="observer">
  <form ref="edit_service_master_form" @submit.prevent="updateServiceMaster">
    <md-card>
      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Service Master
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="code" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Service Master Code</label>
                <md-input v-model="service_master_code" required/>
                <validation-error :errors="apiValidationErrors.service_master_code" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Service Category</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="category" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Service Category</label>
                <md-select v-model="service_category" required>
                  <md-option v-for="option in options_service_category" :key="option.value" :value="option.id">
                    {{ '('+option.service_category_code+') '+option.service_category_name }}
                  </md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.service_master_category_id" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Name</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Service Master Name</label>
                <md-input v-model="service_master_name" required/>
                <validation-error :errors="apiValidationErrors.service_master_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Service Master LTS</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="lts" v-slot="{ errors }">
              <md-field class="md-invalid">
              <label for="">Service Master LTS</label>
                <md-input v-model="service_master_lts" type="text" v-on:keypress="NumbersOnly" required/>
                <validation-error :errors="apiValidationErrors.service_master_lts" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
      </md-card-content>
      <br>
      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import { required } from 'vee-validate/dist/rules';
import { extend , ValidationObserver } from 'vee-validate';
import formMixin from "@/mixins/form-mixin";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);


// validasi pesan error untuk required field
extend('name', {
  ...required,
  message: 'Service Master Name field is required'
});
extend('code', {
  ...required,
  message: 'Service Master Code field is required'
});
extend('category', {
  ...required,
  message: 'Service Master Category field is required'
});
extend('lts', {
  ...required,
  message: 'Service Master Lts field is required'
});

export default {
  name: "edit-service-master-test",
  components: {ValidationError, ValidationObserver},

  mixins: [formMixin],

  data: () => ({
    service_master_code: null,
    service_category: null,
    service_master_name: null,
    service_master_lts: null,
    options_service_category: null,
  }),

  created() {
    this.getServiceMasterData();
  },
  
  methods: {
    // fungsi tombol direct ke list view table
    backtoList(id) {
      this.$router.replace({ name: 'List Service Master' })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    
    // ammbil data service master
    async getServiceMasterData(){
      //check apakah id di route ada
      if(this.$route.params.id){
          
        console.log(this.$route.params.id)
        //jika ada panggil data nota jasa berdasarkan id
        await this.$store.dispatch("workshop_service_master/get", this.$route.params.id)
        this.service_master = await this.$store.getters["workshop_service_master/service_master"]
        await this.$store.dispatch("workshop_service_categories/list")
        this.options_service_category = await this.$store.getters["workshop_service_categories/list"]

        console.log(this.service_master);
        this.service_master_code = this.service_master.service_master_code;
        this.service_category = this.service_master.service_master_category_id;
        this.service_master_name = this.service_master.service_master_name;
        this.service_master_lts = this.service_master.service_master_lts;
      }
      else{
        // jika tidak ada kembali ke list service master
        await this.$router.replace({name: 'List Service Master'});
      }
    },

    //validasi edit data
    async editConfirmation(id) {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.updateServiceMaster(id)
        }
      });
    },

    // fungsi update data
    async updateServiceMaster() {
      if(this.$route.params.id == null || !this.$route.params.id) {
        await this.$store.dispatch("alerts/error", "You are not allowed not change data of default users.")
        return
      }
      const data = {
        id: this.service_master.id,
        type: "workshop_service_masters",
        service_master_code: this.service_master_code,
        service_master_category_id: this.service_category,
        service_master_name: this.service_master_name,
        service_master_lts: this.service_master_lts
      }
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_service_master/update", data)
        // panggil alert success
        await this.$store.dispatch("alerts/success", "Service Master data changed successfully.")
        // kembali ke list service master
        await this.$router.replace({name: 'List Service Master'});
        //this.$refs['password_form'].reset()
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }

    }
  }
};
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>
